import _ from 'lodash'
import { BreakpointsVariantsTo, CssObject } from '../shared.types'
import { mapValues } from './mapValues'
import { BreakpointsVariantsToSelectorsMap } from '../features/responsiveLayout/responsiveLayout.types'

export const clearFutileOverridesFromCssObject = (css: BreakpointsVariantsTo<CssObject | undefined>) => {
	const defaultCss = css.default?.['']

	if (!defaultCss) {
		return css
	}

	const equalCss = mapValues(defaultCss, (cssValue, cssProperty) =>
		Object.values(css).every((breakpoint) =>
			Object.values(breakpoint).every((x) => {
				const value = x?.[cssProperty]
				return typeof value === 'undefined' || value === cssValue
			})
		)
	)

	// omit all css properties that are equal to the default breakpoint
	return mapValues(css, (breakpoint) =>
		mapValues(breakpoint, (cssValue) => {
			if (cssValue === defaultCss || !cssValue) {
				return cssValue
			}

			return _.omitBy(cssValue, (__, property) => equalCss?.[property])
		})
	)
}

export const clearFutileOverridesFromSelectorsMap = (css: BreakpointsVariantsToSelectorsMap) => {
	const defaultCss = css.default?.['']

	if (!defaultCss) {
		return css
	}

	const equalCss = mapValues(defaultCss, (cssObject, selector) =>
		mapValues(cssObject, (cssValue, cssProperty) =>
			Object.values(css).every((breakpoint) =>
				Object.values(breakpoint).every((x) => {
					const value = x?.[selector]?.[cssProperty]
					return typeof value === 'undefined' || value === cssValue
				})
			)
		)
	)

	// omit all css properties that are equal to the default breakpoint
	return mapValues(css, (breakpoint) =>
		mapValues(breakpoint, (cssObject) => {
			if (cssObject === defaultCss) {
				return cssObject
			}

			return mapValues(cssObject, (cssValue, selector) => {
				if (equalCss?.[selector]) {
					return _.omitBy(cssValue, (__, property) => equalCss?.[selector]?.[property])
				}

				return cssValue
			})
		})
	)
}
